import { atom } from 'jotai';
import { OutTaskboxDetailResponse } from 'queries/model';

export const taskboxDetailViewAtom = atom<OutTaskboxDetailResponse | null>(null);
export const syncTaskboxDetailViewAtom = atom<(OutTaskboxDetailResponse & { syncType: string }) | null>(null);
